import React from 'react';

const ButtonPrimary: React.FC<ButtonProps> = ({ text, disabled, onClick }) => (
    <button type="button"
            disabled={disabled}
            onClick={() => onClick? onClick() : undefined}
            className="w-full text-white bg-fred-purple-500 hover:bg-fred-blue-500 font-semibold rounded-lg text-base px-4 py-4 text-center inline-flex items-center justify-center cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400">
      {text}
    </button>
);

export default ButtonPrimary;
